import { render, staticRenderFns } from "./TileSmall.vue?vue&type=template&id=a99628c6&"
import script from "./TileSmall.vue?vue&type=script&lang=js&"
export * from "./TileSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports